export enum PhaseCategoryEnum {
  Material = 'Material',
  Production = 'Production',
  Warranty = 'Warranty',
}
